import _     from 'lodash'
import Model from './model'
import { BelongsTo, HasMany, HasManyThrough } from './associations'

export default class AssociationProxy
  constructor: (@entity, @associationInjector) ->
    { @associations, @entitySpace, @collectionConstructor } = @associationInjector

    @associations.forEach (association) =>
      return unless @entity instanceof association.sourceModel

      getter = switch association.constructor
        when BelongsTo      then @_belongsToGetter(association)
        when HasMany        then @_hasManyGetter(association)
        when HasManyThrough then @_hasManyThroughGetter(association)

      Object.defineProperty(@, association.name, get: getter)

  _belongsToGetter: (association) ->
    -> # this must return a function
      map = @entitySpace.mapForOrNull(association.destinationModel)

      throw @_associationNotLoaded(association) unless map

      pk = @entity[association.foreignKey]

      return null unless pk?

      entity = map.get(pk)

      throw @_destinationModelNotLoaded(association, pk) unless entity

      @associationInjector.inject(entity)

  _hasManyGetter: (association) ->
    -> # this must return a function
      map = @entitySpace.mapForOrNull(association.destinationModel)

      throw @_associationNotLoaded(association) unless map

      collection = @collectionConstructor.with(map, association.destinationModel,
                                               @entitySpace, @associationInjector)

      collection.where (record) => record[association.foreignKey] == @entity.pk

  _hasManyThroughGetter: (association) ->
    -> # this must return a function
      model      = association.sourceModel
      collection = @collectionConstructor.with([@entity], model, @entitySpace, @associationInjector)

      for name in association.assocNames
        assoc      = @associations.findBy(model, name)
        model      = assoc.destinationModel
        collection = @_assocUnionFor(collection, model, name)

      collection

  _assocUnionFor: (collection, model, assocName) ->
    if collection.size()
      collections = collection.map (entity) => @_collectionFor(entity.associations[assocName], model)

      @collectionConstructor.union(collections)
    else
      @_collectionFor(null, model)

  _collectionFor: (entities, model) ->
    if entities instanceof @collectionConstructor
      entities
    else if entities instanceof Model
      @collectionConstructor.with([entities], model, @entitySpace, @associationInjector)
    else if entities is null
      @collectionConstructor.with([], model, @entitySpace, @associationInjector)
    else
      throw new Error('bad entities param for AssociationProxy._collectionFor:', entities)

  _associationNotLoaded: (association) ->
    new Error("association #{association.sourceModel.name}.#{association.name} not loaded")

  _destinationModelNotLoaded: (association, pk) ->
    new Error("#{association.destinationModel.name} with pk #{pk} for association " +
              "#{association.sourceModel.name}.#{association.name} not loaded")
